import TourListingPage from "../components/tours/TourListingPage";

export default function MyToursPage() {
  return (
    <TourListingPage
    myToursOnly
    title="My Tours"
    description="View your upcoming and completed tours, travel history, and journey details."
    icon="fa-plane"
    emptyTitle="No Tour Applications"
    emptyMessage="You have not applied for a tour yet."
    badgeVisibility="false"
    />
  );
}
